import { Bind, Debounce } from '@/utils/Decorator'
import {
  Button,
  Checkbox,
  Col,
  Row
} from '@/plugins/ant-design-vue/tsx-support'
import { CommonLoading } from '@/components/business-components'
import {
  CommonSwitchStatus,
  LoginRegistryQuickEntry,
  NormalLoginFormData,
  RewardBindData,
  RewardBindType
} from '@/api/common/type'
import { Component, Ref, Watch } from '@/vue-property-decorator'
import { GameCategoryIds } from '@/views/game/consts/categorys'
import { GameNavigation } from '@/views/game/classes'
import { GeeGuard } from '@/controller/GeeTest'
import {
  LoginFormState,
  LoginRegisterName,
  LoginRegisterValue,
  OnNeedRegister,
  RegisterFormState,
  Themes
} from '../components/login-register-form/types'
import { OpenOptions as LoginRegisterSettingOpenOptions } from '../login-registry-setting'
import { LogoBox } from '@/layouts/components/header/components'
import { MainState } from '@/store/index/type'
import { NoticeType } from '@/views/notice/const'
import { Portal } from 'portal-vue'
import { RouteName } from '@/router/config'
import { Tab, Tabs } from '@/plugins/vant/tsx-support'
import { VerifyScene } from '../verify-bind-phone/const'
import {
  apiGetActiveRewardBindBeforeLogin,
  apiGetSystemStatus,
  apiGetUserAgreementInfos,
  apiGetUserInfo
} from '@/api/common'
import { createSvgSprite } from '@/utils/business-utils/assets'
import { currencyFormatter } from '@/utils/FormatterUtils'
import { useGameStore } from '@/views/game/store'
import { useHomeStore } from '@/store/home'
import { useI18n } from '@/i18n'
import { useMainStore } from '@/store/index'
import { useSecurity } from '@/views/center/security/store'
import BusinessUtils from '@/utils/business-utils'
import LoginFrom from '../components/login-register-form/login'
import Modal from '@/controller/Modal'
import ModalBase from '@/mixins/business/modal/modal-base'
import RegisterFrom from '../components/login-register-form/register'
import Site from '@/controller/Site'
import Skin from '@/controller/Skin'
import TabTitle from '../components/login-register-form/tab-title'
import ThreeWayLogin from '@/components/business-components/three-way-bind'
import TooltipsComp from '@/components/business-components/tooltips'
import styles from './style.module.scss'
import to from 'await-to-js'

const enum isPop {
  visible = 1,
  unVisble = 0
}
interface State {
  benefitMap: Map<string, RewardBindData> | undefined
}
export interface OpenOptions {
  login?: true
  register?: true
  onLoginSuccess?: () => void
  onLoginError?: () => void
  renderMode?: 'modal' | 'portal'
  beforeOpen?: () => void
  afterClose?: () => void
  defaultActiveKey?: LoginRegisterName
}
@Component<LoginRegisterModal>({ name: 'LoginRegisterModal' })
export default class LoginRegisterModal extends ModalBase {
  @Ref()
  private refHtml!: HTMLDivElement
  /** 当前选择的手机区号 */
  private currentPhoneNumberSegment = ''
  /** 是否勾选协议 */
  private agreed = true // 默认勾选
  private activeKey: LoginRegisterName = LoginRegisterName.Account
  private tabTitle: Record<string, string> = {}
  private loading = false
  private loginRegisterFormMaxHeight = '0px'
  private openOptions: OpenOptions = {}
  private agreementHtmlContent = ''
  private isAgreementFetching = false

  state: State = {
    benefitMap: undefined
  }

  /**
   * 获取新人福利气泡
   */
  async getNewComerBenefit() {
    const getBenefitReward = useMainStore().getBenefitReward
    try {
      const result = await to(apiGetActiveRewardBindBeforeLogin())
      const dataPop = result[1]?.list as unknown as RewardBindData[]
      const benefit: MainState['registerBubbleData'] = {}
      const currency = result[1]?.currency
      dataPop.forEach((item) => {
        if (item.bindType === RewardBindType.Register) {
          benefit[LoginRegisterName.Account] = getBenefitReward(
            item,
            currency || ''
          )
        } else if (item.bindType === RewardBindType.BindEmail) {
          benefit[LoginRegisterName.Email] = getBenefitReward(
            item,
            currency || ''
          )
        } else if (item.bindType === RewardBindType.SMSValid) {
          benefit[LoginRegisterName.Phone] = getBenefitReward(
            item,
            currency || ''
          )
        }
      })
      benefit.currency = currency
      useMainStore().setRegisterBubbleData(benefit)
    } catch (err) {}
  }
  get benefitMap() {
    return useMainStore().registerBubbleData
  }
  /** 表单内币种 */
  registerFormCurrency = useMainStore().userInfos?.currency
  @Watch('registerFormCurrency')
  currencyChange() {
    const { setRegisterBubbleData, getBenefitReward } = useMainStore()
    const list = ['account', 'email', 'phone']
    const currency = 'currency'
    list.forEach((item) => {
      const key = item as unknown as keyof typeof this.benefitMap
      key !== currency &&
        (this.benefitMap[key] = getBenefitReward(
          this.benefitMap[key] as RewardBindData,
          this.benefitMap?.currency || '',
          this.registerFormCurrency
        ))
    })
    setRegisterBubbleData(this.benefitMap)
  }
  /** 表单内币种修改 */
  setBenefitAmount(value: string) {
    this.registerFormCurrency = value
  }
  async mounted() {
    //登录 注册 安全中心每次打开都拉接口
    const { updateSystemInfos, osType } = useMainStore()
    const response = await apiGetSystemStatus({ osType })
    const systemInfos = response!.data?.data?.homeGetSysInfo
    if (systemInfos) {
      updateSystemInfos(systemInfos)
    }
    this.getNewComerBenefit()
  }

  /** 控制气泡展示 */
  get isbubbleV() {
    const { autoFillData } = useMainStore()
    // 登录弹窗本地有账号缓存时不显示注册送，注册弹窗不受影响
    // 账号登录tab气泡不显示
    let account = false
    if (this.openOptions?.register) {
      account =
        this.benefitMap[LoginRegisterName.Account]?.isPop === 1 &&
        !!this.benefitMap[LoginRegisterName.Account]?.reward
    } else {
      account =
        this.benefitMap[LoginRegisterName.Account]?.isPop === 1 &&
        !!this.benefitMap[LoginRegisterName.Account]?.reward &&
        !autoFillData
    }
    return {
      account,
      phone:
        (this.benefitMap[LoginRegisterName.Phone]?.isPop === isPop.visible &&
          !!this.benefitMap[LoginRegisterName.Phone]?.reward &&
          !this.isPhoneExist &&
          !autoFillData) ||
        (account && !this.isPhoneExist),
      email:
        (this.benefitMap[LoginRegisterName.Email]?.isPop === isPop.visible &&
          !!this.benefitMap[LoginRegisterName.Email]?.reward &&
          !this.isEmailExist &&
          !autoFillData) ||
        (account && !this.isEmailExist)
    }
  }
  private get theme() {
    const { homeLayoutInfos } = useMainStore()
    switch (Number(homeLayoutInfos?.commonConfig?.registerLogin)) {
      case Themes.Theme3:
        return {
          logo: true,
          label: true,
          tabIcon: true,
          theme: Themes.Theme3,
          /** 只有一个tab时是否隐藏tab */
          onlyOneTabHidden: true
        }
      case Themes.Theme2:
        return {
          logo: true,
          label: false,
          tabIcon: false,
          theme: Themes.Theme2,
          /** 只有一个tab时是否隐藏tab */
          onlyOneTabHidden: true
        }
      case Themes.Theme1:
      default:
        return {
          logo: false,
          label: false,
          tabIcon: true,
          theme: Themes.Theme1,
          /** 只有一个tab时是否隐藏tab */
          onlyOneTabHidden: false
        }
    }
  }
  private get tabIcon() {
    const { homeLayoutInfos } = useMainStore()
    switch (Number(homeLayoutInfos?.commonConfig?.registerLogin)) {
      case Themes.Theme3:
        return {
          phone: 'login_icon_sj',
          email: 'login_icon_yx',
          account: 'login_icon_zh'
        }
      case Themes.Theme2:
      case Themes.Theme1:
      default:
        return {
          phone: 'input_icon_sj',
          email: 'input_icon_yj',
          account: 'input_icon_zh'
        }
    }
  }
  private get tabs() {
    const { t } = useI18n()
    const { systemInfos } = useMainStore()
    type TabsEnum = {
      key: LoginRegisterName
      icon: string
      title: ReturnType<typeof t>
      subTitle?: ReturnType<typeof t>
    }
    const showTabIcon = this.theme.tabIcon
    const enumTabs: Record<string, TabsEnum> = {
      [LoginRegisterValue.Account]: {
        key: LoginRegisterName.Account,
        icon: this.tabIcon.account,
        title: this.openOptions?.register
          ? t('lobby.modal.login.tabs.accountRegister')
          : t('lobby.modal.login.tabs.accountLogin'),
        subTitle: undefined
      },
      [LoginRegisterValue.Phone]: {
        key: LoginRegisterName.Phone,
        icon: this.tabIcon.phone,
        title: this.openOptions?.register
          ? t('lobby.modal.login.tabs.phoneRegister')
          : t('lobby.modal.login.tabs.phoneLogin'),
        subTitle: t('lobby.modal.login.tabs.phoneSubTitle')
      },
      [LoginRegisterValue.Email]: {
        key: LoginRegisterName.Email,
        icon: this.tabIcon.email,
        title: this.openOptions?.register
          ? t('lobby.modal.login.tabs.emailRegister')
          : t('lobby.modal.login.tabs.emailLogin'),
        subTitle: t('lobby.modal.login.tabs.emailSubTitle')
      }
    }
    const tabArray = (systemInfos?.registerTabSort ?? '1,2,3')
      .split(',')
      .map(Number)
    return tabArray.map((tab) => {
      const { key, icon, title, subTitle } = enumTabs[tab]
      return {
        key,
        title: (
          <span class={styles.tabsLabel}>
            {showTabIcon && (
              <icon-sprite
                class={styles.tabsLabelIcon}
                sprite={createSvgSprite(icon)}
              />
            )}
            {title}
          </span>
        ),
        subTitle
      }
    })
  }
  private get options() {
    return {
      /** 登录注册弹框的主题 */
      theme: this.theme.theme,
      /** 是否显示logo */
      logo: this.theme.logo,
      /** 是否显示label */
      label: this.theme.label,
      /** 动态tabs */
      tabs: this.tabs
    }
  }
  private get quickEntry() {
    const { systemInfos } = useMainStore()
    const isOpen = (value?: number) => value === CommonSwitchStatus.OPEN

    const typeName = `${this.activeKey}Register`
    const configRegistry = Reflect.get(systemInfos || {}, typeName)

    const quickEntryConfig = configRegistry?.quickEntry as
      | LoginRegistryQuickEntry
      | undefined

    let freeTryit = false
    let forgetPass = false
    let customer = false
    let instantLogin = false
    let instantRegister = false

    switch (this.activeKey) {
      case LoginRegisterName.Email:
      case LoginRegisterName.Phone: {
        freeTryit = isOpen(quickEntryConfig?.quickEntryFree)
        forgetPass = isOpen(quickEntryConfig?.quickEntryForgetPassword)
        customer = isOpen(quickEntryConfig?.quickEntryCustomer)
        break
      }
      case LoginRegisterName.Account: {
        if (this.openOptions?.register) {
          freeTryit = isOpen(quickEntryConfig?.registerQuickEntryFree)
          // forgetPass = false
          customer = isOpen(quickEntryConfig?.registerQuickEntryCustomer)
          instantLogin = isOpen(quickEntryConfig?.registerQuickEntryInstant)
          // instantRegister = false
        } else {
          freeTryit = isOpen(quickEntryConfig?.loginQuickEntryFree)
          forgetPass = true
          customer = isOpen(quickEntryConfig?.loginQuickEntryCustomer)
          // instantLogin = false
          instantRegister = isOpen(quickEntryConfig?.loginQuickEntryInstant)
        }
        break
      }
    }
    return {
      freeTryit: freeTryit && this.tryItGameOpen,
      forgetPass,
      customer,
      instantLogin,
      instantRegister
    }
  }

  private onTabsChange(key: LoginRegisterName) {
    const { updateAutoFillDataType, userInfos } = useMainStore()
    this.registerFormCurrency = userInfos?.currency
    updateAutoFillDataType(key)
  }

  private onTabTitle(key: LoginRegisterName, width: number) {
    this.$set(this.tabTitle, key, width + 30 + 'px')
  }

  private initOpenType(options: OpenOptions): OpenOptions {
    const { getAutoFillData } = useMainStore()
    if (options.login || options.register) return options

    /** @是否登录过 是否有登录的记录 */
    const logged = Object.keys(getAutoFillData()).length > 0
    if (logged) {
      return { ...options, login: true }
    }
    return { ...options, register: true }
  }

  public async open(options: OpenOptions = {}) {
    options?.beforeOpen?.()
    this.openOptions = this.initOpenType(options)
    GeeGuard.preloadGeeGuardToken()

    if (
      this.options.tabs.find((d) => d.key === LoginRegisterName.Account) &&
      this.openOptions?.defaultActiveKey === LoginRegisterName.Account
    ) {
      this.activeKey = LoginRegisterName.Account
    } else {
      this.activeKey = this.options.tabs[0].key
    }

    this.onTabsChange(this.activeKey)

    await Site.initSmsCountry()
    this.tryInitCurrentPhoneNumberSegment()

    if (this.openOptions?.register) {
      await Site.initChannelIpBindInfo()
    }

    await this.baseOpen()
  }

  /** 初始化手机区号 */
  private tryInitCurrentPhoneNumberSegment() {
    const { ipCheck, defaultCountry, getAutoFillData } = useMainStore()
    const countryInfos = useMainStore().countryInfos || []
    const cacheAutoFillData = getAutoFillData()

    if (!countryInfos.length) {
      return
    }

    const findCountry = [
      /** 用户上次登录注册记录下的区号 */
      cacheAutoFillData.phoneNumberSegment,
      /** ip推荐区号 */
      ipCheck.recommendAreaCode,
      /** 区号列表返回的默认区号 */
      defaultCountry?.phoneNumberSegment,
      /** 兜底默认展示列表第一个区号 */
      countryInfos[0].phoneNumberSegment
    ]
      .filter(Boolean)
      .find((phoneNumberSegment) =>
        countryInfos.find(
          (item) => item.phoneNumberSegment === phoneNumberSegment
        )
      )

    if (findCountry) {
      this.currentPhoneNumberSegment = findCountry
    }
  }

  /** 重写afterClose 存储当前弹窗关闭类型 */
  public afterClose() {
    const store = useMainStore()
    if (store.enterPagePopupType === 1) {
      store.$patch({ enterPagePopupType: 0 })
    }
    this.openOptions?.afterClose?.()
    this.baseAfterClose()
  }

  /** 忘记密码 */
  private async forgetPassword() {
    const { enterPagePopupType, $patch } = useMainStore()
    const { isGalaxyGold, isCrownGold } = Skin.currentTheme()
    const { setLoginPanel } = useHomeStore()
    if (enterPagePopupType === 1) {
      $patch({ enterPagePopupType: 3 })
    }
    await this.close()
    if (isGalaxyGold || isCrownGold) {
      setLoginPanel(false)
    }
    Modal.open('forgotPasswordModal')
  }

  /** 免费试玩 */
  private async freeTryIt() {
    const { setLoginPanel } = useHomeStore()
    const { isGalaxyGold, isCrownGold } = Skin.currentTheme()
    this.close()
    if (isGalaxyGold || isCrownGold) {
      setLoginPanel(false)
    }
    useMainStore().$patch({ enterPagePopupType: 0 })
    GameNavigation.goSubGameDemoPage()
  }

  /** 阅读协议 */
  private async openUserAgreementModal() {
    const { t } = useI18n()
    this.agreementHtmlContent = ''
    Modal.create({
      class: styles.agreenmentModal,
      okText: t('lobby.modal.register.readed') as string,
      cancelButtonProps: {
        style: {
          display: 'none'
        }
      },
      closable: true,
      content: () => {
        return (
          <div class={styles.agreenmentModalScroll}>
            <CommonLoading spinning={this.isAgreementFetching}>
              <my-scroll>
                <my-adapter
                  class={styles.scrollContent}
                  html={this.agreementHtmlContent}
                  mode={'innerHTML'}
                />
              </my-scroll>
            </CommonLoading>
          </div>
        )
      }
    })
    this.isAgreementFetching = true
    const response = await apiGetUserAgreementInfos().finally(() => {
      this.isAgreementFetching = false
    })
    this.agreementHtmlContent = response.data.data?.content || ''
  }

  /** 联系客服 */
  private handleServiceClick() {
    this.close()
    this.$router.push({
      name: RouteName.NOTICE,
      query: {
        noticeType: `${NoticeType.SERVICE}`
      }
    })
  }

  get tryItGameOpen() {
    return useGameStore().gameCategoriesAvailable.find(
      (item) => item.gameCategoryId === GameCategoryIds.Demo
    )?.display
  }

  /** 订阅 visible */
  @Watch('visible')
  protected async onVisibleChange() {
    if (this.visible) {
      window.addEventListener('keyup', this.onKeyup)
    } else {
      window.removeEventListener('keyup', this.onKeyup)
    }
  }

  /** 按下回车键调用登录 */
  @Bind()
  @Debounce(500)
  private onKeyup(e: KeyboardEvent) {
    if (this.isKeptAlive) {
      return
    }
    if (e.code === 'Enter') {
      this.submit()
    }
  }

  refForm() {
    switch (this.activeKey) {
      case LoginRegisterName.Account:
        return this.openOptions?.register
          ? (this.$refs['refFormRegisteraccount'] as LoginFrom)
          : (this.$refs['refFormLoginaccount'] as RegisterFrom)
      case LoginRegisterName.Phone:
        return this.$refs['refFormLoginphone'] as LoginFrom
      case LoginRegisterName.Email:
        return this.$refs['refFormLoginemail'] as LoginFrom
    }
    return undefined
  }

  private submit() {
    const { t } = useI18n()
    if (this.needShowAgreed && !this.agreed) {
      Modal.message({
        type: 'error',
        content: () => t('lobby.modal.register.agreementRequiredTips')
      })
      return
    }
    this.refForm()?.submit()
  }

  /** 是否需要展示用户协议 */
  private get needShowAgreed() {
    return !(
      this.activeKey === LoginRegisterName.Account &&
      !this.openOptions?.register
    )
  }

  private onLoginSuccess(payload: LoginFormState) {
    /**
     * 登录成功
     * 通过账号密码登录的用户进行标记，安全中心时可省略第一步验证密码
     */
    if (this.activeKey === LoginRegisterName.Account) {
      const { $patch } = useSecurity()
      $patch({
        isLoginedByPassword: true,
        loginPass: payload.userpass
      })
    }
    const routeName = this.$route.name
    if (routeName === RouteName.EVENT || routeName === RouteName.EVENT_ITEM) {
      this.$router.push({
        name: RouteName.GAME
      })
    }
    this.close()
    useMainStore().$patch({ geeGuardToken: '' })
    this.openOptions?.onLoginSuccess?.()
    Modal.close('rechargePopup')
    Modal.close('newBenefitsModal')
  }
  private onNeedRegister({ form, registrable }: OnNeedRegister) {
    const { isGalaxyGold, isCrownGold } = Skin.currentTheme()
    const { setGalaxyGoldCurrentTab } = useHomeStore()
    /**
     * 手机号登录 ==> 未注册绑定过
     * 邮箱登录   ==> 未注册绑定过
     * 账号登录   ==> 未注册绑定过
     */

    const { systemInfos } = useMainStore()

    let password: number | undefined = 0

    let email = undefined
    if (this.activeKey === LoginRegisterName.Email) {
      email = form.email ?? undefined
      password = systemInfos?.emailRegister?.password
    }
    let mobilePhoneNumber = undefined
    if (this.activeKey === LoginRegisterName.Phone) {
      mobilePhoneNumber = form.phone ?? undefined
      password = systemInfos?.phoneRegister?.password
    }

    const isPassWdNoInput = Number(password) >= 2
    Modal.open('loginRegisterSettingModal', {
      renderMode: this.openOptions?.renderMode,
      onRegisterSuccess: this.openOptions?.onLoginSuccess,
      mode: this.activeKey,
      platformId: registrable.username,
      passwd: isPassWdNoInput ? undefined : registrable.password,
      mobilePhoneNumber,
      email,
      phoneNumberSegment: this.currentPhoneNumberSegment
    } as LoginRegisterSettingOpenOptions)
    if (isGalaxyGold || isCrownGold) {
      setGalaxyGoldCurrentTab('register')
    }

    this.close()
  }
  private async onVeriryBindPhone(payload: LoginFormState) {
    try {
      const data = await apiGetUserInfo({ username: payload.username })
      const userInfo = data?.data?.data
      if (!userInfo) {
        return Promise.reject()
      }
      await this.close()
      Modal.open('veriryBindPhone', {
        verifyScene: VerifyScene.LOGIN_SMS_VERIFY,
        formData: {
          username: payload.username,
          userpass: payload.userpass,
          loginType: {
            [LoginRegisterName.Account]: 1,
            [LoginRegisterName.Phone]: 2,
            [LoginRegisterName.Email]: 3,
            [LoginRegisterName.ThirdParty]: 0
          }[this.activeKey] as NormalLoginFormData['loginType'],
          email: payload.email,
          phone: payload.phone,
          captcha: payload.phoneCode
        },
        desensitizedPhoneNumber: userInfo?.phone,
        onSuccess: () => {
          Modal.close('veriryBindPhone')
          this.openOptions?.onLoginSuccess?.()
        }
      })
    } catch (error) {
      return Promise.reject(error)
    }
  }

  private onRegisterSuccess(payload: RegisterFormState) {
    this.close()
    // 账号注册不显示保存图片，改成直接成功
    this.registerSuccessShowModal()
    /** 新注册的账号进行状态标记，安全中心时可省略第一步验证密码 */
    const { $patch } = useSecurity()
    $patch({
      isLoginedByRegister: true,
      loginPass: payload.passwd
    })
    useMainStore().$patch({
      geeGuardToken: ''
    })
    // 登录成功回调
    this.openOptions?.onLoginSuccess?.()
  }

  /** 是否邮箱绑定 */
  get isEmailExist() {
    return useMainStore().isEmailExist
  }
  /** 是否手机绑定 */
  get isPhoneExist() {
    return useMainStore().isPhoneExist
  }
  /** 气泡文本数据 */
  get bubbleTextData() {
    const data: { [x: string]: string | boolean } = {}
    for (const val of Object.values(LoginRegisterName)) {
      data[val] = this.getBubbleText(
        val as LoginRegisterName,
        this.isbubbleV,
        this.benefitMap
      )
    }
    return data
  }
  /** 计算生成对应气泡文本 */
  getBubbleText(
    key: LoginRegisterName,
    isbubbleV: LoginRegisterModal['isbubbleV'],
    benefitMap: LoginRegisterModal['benefitMap']
  ) {
    const t = useI18n().t
    const { userInfos } = useMainStore()

    const str1 =
      t('lobby.modal.login.operate.registerGive') +
      ' ' +
      currencyFormatter(benefitMap[LoginRegisterName.Account]?.reward || 0, {
        code: userInfos?.currency,
        precision: 2,
        symbol: ''
      })
    const str2 = ' \n&'
    const str3 =
      t('lobby.modal.login.operate.bindingGive') +
      ' ' +
      currencyFormatter(Reflect.get(benefitMap, key)?.reward || 0, {
        code: userInfos?.currency,
        precision: 2,
        symbol: ''
      })
    if (key === LoginRegisterName.Account) {
      return benefitMap[key]?.reward !== 0 ? str1 : ''
    } else {
      if (!!Reflect.get(benefitMap, key)?.reward) {
        return isbubbleV[LoginRegisterName.Account] ? str1 + str2 + str3 : str3
      } else {
        return str1
      }
    }
  }

  private registerSuccessShowModal() {
    const { t } = useI18n()
    const modal = Modal.create({
      title: t('lobby.modal.register.successRegister'),
      titleType: 'success',
      width: BusinessUtils.px2rem(600),
      content: () => {
        return (
          <span style={{ display: 'flex', justifyContent: 'center' }}>
            {t('lobby.modal.register.successTips')}
          </span>
        )
      },
      closable: true,
      hiddenBtns: false,
      okText: t('lobby.modal.pay.payBtn').toString(),
      cancelButtonProps: {
        style: {
          display: 'none'
        }
      },
      onOk: async () => {
        await modal.destroy()
        Modal.open('payModal')
      }
    })
  }

  private async toAccountLogin() {
    const openOptions = this.openOptions

    await this.close()
    setTimeout(() => {
      Modal.openLoginRegisterModal({
        ...openOptions,
        login: true,
        register: undefined,
        defaultActiveKey: LoginRegisterName.Account
      })
    })
  }
  private async toAccountRegister() {
    const openOptions = this.openOptions

    await this.close()
    setTimeout(() => {
      Modal.openLoginRegisterModal({
        ...openOptions,
        login: undefined,
        register: true,
        defaultActiveKey: LoginRegisterName.Account
      })
    })
  }

  private get accountRegister() {
    return (
      this.openOptions?.register && this.activeKey === LoginRegisterName.Account
    )
  }

  private get submitOptions() {
    const { t } = useI18n()
    if (this.activeKey === LoginRegisterName.Account) {
      if (this.accountRegister) {
        return {
          type: 'accountRegister',
          submitText: `${t('lobby.modal.register.label')}`
        }
      } else {
        return {
          type: 'accountLogin',
          submitText: `${t('lobby.modal.login.label')}`
        }
      }
    }
    return {
      type: 'loginRegister',
      submitText: `${t('lobby.modal.register.label')}/${t(
        'lobby.modal.login.label'
      )}`
    }
  }

  private get thirdPartys() {
    return useMainStore().threeWayConfig.list
  }

  private renderContent() {
    const { t } = useI18n()
    const { rememberPwd, updateRememberPwd } = useMainStore()
    /** 账号登录时不展示气泡 */
    const isAccountLogin = (key: string) => {
      if (key === LoginRegisterName.Account && !this.openOptions?.register) {
        return false
      }
      return true
    }
    return (
      <div
        ref="refHtml"
        class={styles.loginRegistry}
        data-theme={this.options.theme}
      >
        <div
          v-show={this.options.logo}
          class={styles.logoImage}
          data-left-right-padding
        >
          <LogoBox />
        </div>

        <Tabs
          data-theme={this.options.theme}
          data-onlyone-hidden={
            this.options.tabs.length === 1 && this.theme.onlyOneTabHidden
          }
          ellipsis={false}
          v-model={this.activeKey}
          class={styles.tabs}
          animated
          style={{ '--tab-line-width': this.tabTitle[this.activeKey] }}
          onChange={this.onTabsChange}
        >
          {this.options.tabs.map(({ key, title, subTitle }) => (
            <Tab key={key} name={key}>
              <template slot="title">
                <TabTitle onWidth={(width) => this.onTabTitle(key, width)}>
                  {title}
                  {this.activeKey !== key &&
                    isAccountLogin(key) &&
                    Reflect.get(this.isbubbleV, key) && (
                      <TooltipsComp
                        class={
                          key === LoginRegisterName.Account ||
                          !this.isbubbleV[LoginRegisterName.Account] ||
                          !Reflect.get(this.benefitMap, key)?.reward
                            ? styles.toolTips2
                            : styles.toolTips
                        }
                        right={'none'}
                        left={'none'}
                        text={this.bubbleTextData[key] as string}
                        charge={1.1}
                      />
                    )}
                </TabTitle>
              </template>

              <div v-show={subTitle} class={styles.tabSubTitle}>
                {subTitle}
              </div>

              {this.accountRegister ? (
                <RegisterFrom
                  key={this.activeKey}
                  ref={`refFormRegister${key}`}
                  showLabel={this.options.label}
                  type={LoginRegisterName.Account}
                  defaultDisableUsername={false}
                  defaultDisablePassword={false}
                  defaultVisiblePassword={false}
                  onLoading={(loading) => (this.loading = loading)}
                  currentPhoneNumberSegment={this.currentPhoneNumberSegment}
                  onCurrentPhoneNumberSegment={(currentPhoneNumberSegment) =>
                    (this.currentPhoneNumberSegment = currentPhoneNumberSegment)
                  }
                  onSetBenefitAmount={(value: string) =>
                    this.setBenefitAmount(value)
                  }
                  onRegisterSuccess={this.onRegisterSuccess}
                />
              ) : (
                [
                  <LoginFrom
                    key={this.activeKey}
                    ref={`refFormLogin${key}`}
                    type={key}
                    showLabel={this.options.label}
                    currentPhoneNumberSegment={this.currentPhoneNumberSegment}
                    onCurrentPhoneNumberSegment={(currentPhoneNumberSegment) =>
                      (this.currentPhoneNumberSegment =
                        currentPhoneNumberSegment)
                    }
                    onLoading={(loading) => (this.loading = loading)}
                    onLoginSuccess={this.onLoginSuccess}
                    onNeedRegister={this.onNeedRegister}
                    onVeriryBindPhone={this.onVeriryBindPhone}
                  />,
                  <Row.Tsx
                    data-left-right-padding
                    type="flex"
                    justify="space-between"
                    align="middle"
                  >
                    <Col.Tsx>
                      {this.activeKey === LoginRegisterName.Account && (
                        <Checkbox.Tsx
                          checked={rememberPwd}
                          onChange={() => updateRememberPwd(!rememberPwd)}
                          class={[styles.checkbox, styles.btnCheckboxFontSize]}
                        >
                          {t('lobby.modal.login.operate.rememberPwd')}
                        </Checkbox.Tsx>
                      )}
                    </Col.Tsx>
                    <Col.Tsx>
                      {this.activeKey === LoginRegisterName.Account &&
                        this.quickEntry.forgetPass && (
                          <Button.Tsx
                            type="link"
                            style={{ height: 'unset' }}
                            class={[
                              styles.textColor,
                              styles.btnCheckboxFontSize
                            ]}
                            onClick={this.forgetPassword}
                          >
                            {t('lobby.modal.forgotPassword.title')}？
                          </Button.Tsx>
                        )}
                    </Col.Tsx>
                  </Row.Tsx>
                ]
              )}
            </Tab>
          ))}
        </Tabs>

        {/* 账号登录不显示，其他显示 */}
        <Row.Tsx v-show={this.needShowAgreed} data-left-right-padding>
          <Col.Tsx>
            <Checkbox.Tsx
              class={[
                styles.checkbox,
                styles.btnCheckboxFontSize,
                styles.agree,
                this.accountRegister ? styles.fillTop : ''
              ]}
              defaultChecked={this.agreed}
              nativeOnClick={(e: MouseEvent) => {
                const dom = e.target as HTMLElement
                if (dom.getAttribute('data-user-agreement')) {
                  e.preventDefault()
                  this.openUserAgreementModal()
                  return false
                }
                if (dom.tagName !== 'INPUT') return
                this.agreed = !this.agreed
              }}
            >
              <inner-html
                type="span"
                text={t('lobby.modal.register.userAgreement') as string}
              />
            </Checkbox.Tsx>
          </Col.Tsx>
        </Row.Tsx>

        <Row.Tsx
          data-space-top
          data-left-right-padding
          type="flex"
          justify="center"
          align="middle"
        >
          <Button.Tsx
            type="primary"
            block
            onClick={this.submit}
            loading={this.loading}
            class={styles.loginRegistryButton}
          >
            {this.submitOptions.submitText}
            {isAccountLogin(this.activeKey) &&
              Reflect.get(this.isbubbleV, this.activeKey) && (
                <TooltipsComp
                  class={[
                    styles.toolTips3,
                    (this.activeKey as string) === LoginRegisterName.Account ||
                    !this.isbubbleV[LoginRegisterName.Account] ||
                    !Reflect.get(this.benefitMap, this.activeKey)?.reward
                      ? styles.toolTips2
                      : styles.toolTips
                  ]}
                  text={this.bubbleTextData[this.activeKey] as string}
                  charge={1.1}
                />
              )}
          </Button.Tsx>
        </Row.Tsx>

        <Row.Tsx
          data-space-top
          data-left-right-padding
          type="flex"
          justify="space-around"
          align="middle"
        >
          {this.quickEntry.customer && (
            <Col.Tsx class={styles.textColor}>
              <Button.Tsx
                type="link"
                class={styles.btnCheckboxFontSize}
                onClick={this.handleServiceClick}
              >
                {t('lobby.common.components.auth.contactUS')}
              </Button.Tsx>
            </Col.Tsx>
          )}

          {this.quickEntry.freeTryit && (
            <Col.Tsx class={styles.textColor}>
              <Button.Tsx
                type="link"
                class={styles.btnCheckboxFontSize}
                onClick={this.freeTryIt}
              >
                {t('lobby.modal.login.operate.tryItFree')}
              </Button.Tsx>
            </Col.Tsx>
          )}

          {this.quickEntry.instantLogin && (
            <Col.Tsx class={styles.textColor}>
              <Button.Tsx
                type="link"
                class={styles.btnCheckboxFontSize}
                onClick={this.toAccountLogin}
              >
                {t('lobby.modal.forgotPassword.loginNow')}
              </Button.Tsx>
            </Col.Tsx>
          )}

          {this.quickEntry.instantRegister && (
            <Col.Tsx class={styles.textColor}>
              <Button.Tsx
                type="link"
                class={styles.btnCheckboxFontSize}
                onClick={this.toAccountRegister}
              >
                {t('lobby.modal.login.operate.registerAccount')}
              </Button.Tsx>
            </Col.Tsx>
          )}

          {this.quickEntry.forgetPass &&
            this.activeKey !== LoginRegisterName.Account && (
              <Col.Tsx class={styles.textColor}>
                <Button.Tsx
                  type="link"
                  class={styles.btnCheckboxFontSize}
                  onClick={this.forgetPassword}
                >
                  {t('lobby.modal.forgotPassword.title')}
                </Button.Tsx>
              </Col.Tsx>
            )}
        </Row.Tsx>

        <ThreeWayLogin
          v-show={!!this.thirdPartys.length}
          data-left-right-padding
          data-space-top
          type="register"
          threeWayConfig={this.thirdPartys}
        />
      </div>
    )
  }

  private modalHeightConfig() {
    if (
      !this.refHtml ||
      !this.visible ||
      parseInt(this.loginRegisterFormMaxHeight)
    ) {
      return
    }

    const modalHeight =
      this.refHtml.closest('.ant-modal')?.getBoundingClientRect().height ?? 0

    const scrollHeight =
      this.refHtml.querySelector('.van-tabs__content')?.getBoundingClientRect()
        .height ?? 0

    /** 基础高度 + 固定最小的上下边距 60px */
    this.loginRegisterFormMaxHeight = `${
      window.innerHeight - (modalHeight - scrollHeight) - 60 * 2
    }px`
  }
  render() {
    this.modalHeightConfig()
    const { isWeb } = useMainStore()
    if (isWeb && this.openOptions?.renderMode === 'portal') {
      return (
        <Portal to="loginPanel">
          <div v-if={this.visible}>{this.renderContent()}</div>
        </Portal>
      )
    }
    return this.renderModal({
      modalConfig: {
        class: [
          'loginRegisterModal',
          'modal-account-info',
          styles.loginRegisterModal
        ],
        style: {
          '--login-register-form-max-height': this.loginRegisterFormMaxHeight,
          'padding-top': !this.options.logo ? '0.4rem' : ''
        },
        props: {
          width: isWeb ? BusinessUtils.px2rem(640) : BusinessUtils.px2rem(690),
          closeIcon: (
            <icon-sprite
              class={!this.options.logo ? 'notLogo' : ''}
              sprite={createSvgSprite('comm_icon_x')}
            />
          )
        },
        attrs: { 'data-theme': this.options.theme }
      },
      fillCloseIconHeight: true,
      renderContent: this.renderContent
    })
  }
}
